import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=467981d7&scoped=true&"
import script from "./Contact.vue?vue&type=script&lang=js&"
export * from "./Contact.vue?vue&type=script&lang=js&"
import style0 from "./Contact.vue?vue&type=style&index=0&id=467981d7&prod&lang=scss&"
import style1 from "./Contact.vue?vue&type=style&index=1&id=467981d7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "467981d7",
  null
  
)

export default component.exports